const NS = 'http://www.w3.org/2000/svg';
function node(ctx, tag, attrs) {
  const element =
    typeof document?.createElementNS === 'function'
      ? document.createElementNS(NS, tag)
      : ctx.e(tag);
  for (const [key, value] of Object.entries(attrs)) element.setAttribute(key, String(value));
  return element;
}
/** Original enamel cube: native button keeps its spoken identity and hit target.
 * Empty sockets and subtle embossed marks remain readable without colour. */
export function blockArtwork(ctx, cell) {
  const art = node(ctx, 'svg', {
    class: 'game-art game-block-art',
    viewBox: '0 0 100 100',
    'aria-hidden': 'true',
    focusable: 'false',
  });
  const add = (tag, attrs) => art.append(node(ctx, tag, attrs));
  if (!cell.value) {
    add('rect', {
      x: 4,
      y: 4,
      width: 92,
      height: 92,
      rx: 8,
      fill: 'color-mix(in srgb, var(--game-colour-3) 8%, var(--game-night))',
      stroke: 'color-mix(in srgb, var(--game-colour-3) 28%, var(--game-night))',
      'stroke-width': 2,
    });
    add('path', { d: 'M12 18H88', fill: 'none', stroke: 'var(--game-white)', opacity: 0.16 });
    add('path', {
      d: 'M15 73Q34 65 51 74T87 72M12 83Q40 76 65 84T89 81',
      fill: 'none',
      stroke: 'var(--game-colour-3)',
      'stroke-width': 1,
      opacity: 0.12,
    });
    add('path', {
      d: 'M10 21V85H87',
      fill: 'none',
      stroke: 'var(--game-shadow)',
      'stroke-width': 4,
    });
    return art;
  }
  add('rect', {
    x: 3,
    y: 3,
    width: 94,
    height: 94,
    rx: 13,
    fill: 'var(--piece-colour)',
    stroke: 'var(--game-night)',
    'stroke-width': 3,
  });
  add('path', { d: 'M8 8H92L78 22H22Z', fill: 'var(--game-white)', opacity: 0.55 });
  add('path', { d: 'M8 8L22 22V78L8 92Z', fill: 'var(--game-white)', opacity: 0.18 });
  add('path', { d: 'M92 8L78 22V78L92 92Z', fill: 'var(--game-night)', opacity: 0.24 });
  add('path', { d: 'M8 92L22 78H78L92 92Z', fill: 'var(--game-night)', opacity: 0.43 });
  add('rect', {
    x: 17,
    y: 17,
    width: 66,
    height: 66,
    rx: 8,
    fill: 'var(--piece-colour)',
    stroke: 'var(--game-white)',
    'stroke-opacity': 0.18,
  });
  add('path', {
    d: 'M20 25Q45 16 78 24L78 36Q47 26 20 35Z',
    fill: 'var(--game-white)',
    opacity: 0.16,
  });
  add('path', {
    d: 'M22 70Q47 63 78 70M24 76Q53 68 76 76',
    fill: 'none',
    stroke: 'var(--game-night)',
    'stroke-width': 1,
    opacity: 0.13,
  });
  add('path', {
    d: 'M18 70V81H81',
    fill: 'none',
    stroke: 'var(--game-white)',
    'stroke-width': 1.5,
    opacity: 0.24,
  });
  const marks = ['M40 50H60M50 40V60', 'M39 39L61 61M61 39L39 61', 'M38 50L50 38L62 50L50 62Z'];
  add('path', {
    d: marks[(cell.value - 1) % marks.length],
    fill: 'none',
    stroke: 'var(--game-white)',
    'stroke-width': 4,
    opacity: 0.32,
    'stroke-linecap': 'round',
  });
  return art;
}
